// extracted by mini-css-extract-plugin
module.exports = {"products":"products_products__593Dv","title":"products_title__3nnZ3","slider":"products_slider__2JKjd"};